export var fonts = {
    main: 'avenirblack',
    secondary: 'avenirmedium',
};
